// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message. 
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    QACCustomHeader,
    QACCustomHeaderFromJSON,
    QACCustomHeaderToJSON,
} from './';

/**
 * 
 * @export
 * @interface TrainingSession
 */
export interface TrainingSession {
    /**
     * Training session identifier
     * @type {number}
     * @memberof TrainingSession
     */
    id: number;
    /**
     * Test case ID to which the session belongs
     * @type {number}
     * @memberof TrainingSession
     */
    testcase: number;
    /**
     * Revision ID that was trained during this run
     * @type {number}
     * @memberof TrainingSession
     */
    testcaserevision: number;
    /**
     * URL used as the base context while replaying the training session
     * @type {string}
     * @memberof TrainingSession
     */
    trainingUrl?: string;
    /**
     * Optional HTTP headers that were injected while replaying the session
     * @type {Array<QACCustomHeader>}
     * @memberof TrainingSession
     */
    customHeaders?: Array<QACCustomHeader>;
    /**
     * User ID that triggered the training session
     * @type {number}
     * @memberof TrainingSession
     */
    triggeredBy?: number;
    /**
     * Total time (in seconds) spent training the test case
     * @type {number}
     * @memberof TrainingSession
     */
    timeTaken?: number;
    /**
     * Total LLM tokens consumed during this session
     * @type {number}
     * @memberof TrainingSession
     */
    tokensConsumed?: number;
    /**
     * Final training result; null indicates that processing is still in progress
     * @type {string}
     * @memberof TrainingSession
     */
    result?: TrainingSessionResultEnum;
    /**
     * Current state of the training session
     * @type {string}
     * @memberof TrainingSession
     */
    status: TrainingSessionStatusEnum;
    /**
     * Optional training video recorded for this session
     * @type {string}
     * @memberof TrainingSession
     */
    videoUrl?: string;
    /**
     * Project ID associated with this training session
     * @type {number}
     * @memberof TrainingSession
     */
    project?: number;
    /**
     * Owning company for the training session
     * @type {number}
     * @memberof TrainingSession
     */
    company?: number;
    /**
     * Queue ID that originally triggered this training session
     * @type {number}
     * @memberof TrainingSession
     */
    queue?: number;
    /**
     * Timestamp when the training session was created
     * @type {Date}
     * @memberof TrainingSession
     */
    createdAt?: Date;
}

export function TrainingSessionFromJSON(json: any): TrainingSession {
    return {
        'id': json['id'],
        'testcase': json['testcase'],
        'testcaserevision': json['testcaserevision'],
        'trainingUrl': !exists(json, 'training_url') ? undefined : json['training_url'],
        'customHeaders': !exists(json, 'custom_headers') ? undefined : (json['custom_headers'] as Array<any>).map(QACCustomHeaderFromJSON),
        'triggeredBy': !exists(json, 'triggered_by') ? undefined : json['triggered_by'],
        'timeTaken': !exists(json, 'time_taken') ? undefined : json['time_taken'],
        'tokensConsumed': !exists(json, 'tokens_consumed') ? undefined : json['tokens_consumed'],
        'result': !exists(json, 'result') ? undefined : json['result'],
        'status': json['status'],
        'videoUrl': !exists(json, 'video_url') ? undefined : json['video_url'],
        'project': !exists(json, 'project') ? undefined : json['project'],
        'company': !exists(json, 'company') ? undefined : json['company'],
        'queue': !exists(json, 'queue') ? undefined : json['queue'],
        'createdAt': !exists(json, 'created_at') ? undefined : new Date(json['created_at']),
    };
}

export function TrainingSessionToJSON(value?: TrainingSession): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'testcase': value.testcase,
        'testcaserevision': value.testcaserevision,
        'training_url': value.trainingUrl,
        'custom_headers': value.customHeaders === undefined ? undefined : (value.customHeaders as Array<any>).map(QACCustomHeaderToJSON),
        'triggered_by': value.triggeredBy,
        'time_taken': value.timeTaken,
        'tokens_consumed': value.tokensConsumed,
        'result': value.result,
        'status': value.status,
        'video_url': value.videoUrl,
        'project': value.project,
        'company': value.company,
        'queue': value.queue,
        'created_at': value.createdAt === undefined ? undefined : value.createdAt.toISOString(),
    };
}

/**
* @export
* @enum {string}
*/
export enum TrainingSessionResultEnum {
    Passed = 'passed',
    Failed = 'failed'
}
/**
* @export
* @enum {string}
*/
export enum TrainingSessionStatusEnum {
    Queued = 'queued',
    Inprogress = 'inprogress',
    Ready = 'ready',
    Failed = 'failed',
    Stopped = 'stopped'
}


